import * as THREE from 'three';
import font from '../../assets/fonts/helvetiker_regular.typeface.json';

const loader = new THREE.FontLoader();

export default class TextLabel {

  static types = {
    align: {
      LEFT: 'left',
      CENTER: 'center',
      RIGHT: 'right'
    },
    verticalAlign: {
      TOP: 'top',
      CENTER: 'center',
      BOTTOM: 'bottom'
    }
  };

  constructor({ text, size, color, name, align, verticalAlign }) {
    this.size = size || 12;
    this.color = color || 0x000000;
    this.name = name || 'text-label';
    this.align = align;
    this.verticalAlign = verticalAlign;

    this.mesh = this.getText(text);
  }

  getText(message) {
    const geometry = new THREE.TextGeometry(message, {
      name: this.name,
      font: loader.parse(font),
      size: this.size,
      height: 0.1,
      curveSegments: 12,
      bevelEnabled: false
    });

    const materials = [
      new THREE.MeshBasicMaterial({
        color: this.color,
        overdraw: 0.5
      }),
      new THREE.MeshBasicMaterial({
        color: 0x000000,
        overdraw: 0.5
      })
    ];

    const mesh = new THREE.Mesh(geometry, materials);
    mesh.geometry.computeBoundingBox();
    const width = mesh.geometry.boundingBox.max.x;
    const height = mesh.geometry.boundingBox.max.y;

    switch (this.align) {
      case TextLabel.types.align.RIGHT: {
        mesh.position.x = -width;

        break;
      }
      case TextLabel.types.align.CENTER: {
        mesh.position.x = -width / 2;

        break;
      }
      default: {
        break;
      }
    }

    switch (this.verticalAlign) {
      case TextLabel.types.verticalAlign.TOP: {
        mesh.position.y = -height;

        break;
      }
      case TextLabel.types.verticalAlign.CENTER: {
        mesh.position.y = -height / 2;

        break;
      }
      default: {
        break;
      }
    }

    const object = new THREE.Object3D();
    object.add(mesh);

    return object;
  }

  render(camera) {
    let scale;

    if (camera.type === 'OrthographicCamera') {
      scale = this.size / camera.zoom;
    } else if (camera.type === 'PerspectiveCamera') {
      scale = this.mesh.position.distanceTo(camera.position) / 1000;
    }

    this.mesh.scale.set(scale, scale, scale);
  }

}



// WEBPACK FOOTER //
// ./src/object-view/objects/text.js